import { render, staticRenderFns } from "./TreatmentsDropdown.vue?vue&type=template&id=0f0c7710"
import script from "./TreatmentsDropdown.vue?vue&type=script&lang=js"
export * from "./TreatmentsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports